import apiClient from "lib/api-client";
import { useMutation } from "@tanstack/react-query";

const syncOrdertoGati = async (payload) => {
    try {
        const response = await apiClient.post(
            "/api/v3/client/vision_order/syncOrder",
            payload
        );

        if (response.status !== 200) {
            throw new Error("Error syncing order to Gati");
        }

        return response.data;
    } catch (error) {
        console.error("syncOrdertoGati error:", error);
        throw error;
    }
};

export const useSyncOrdertoGati = () => {
    return useMutation({
        mutationFn: syncOrdertoGati,
        onSuccess: (data) => {
            console.log("Sync success", data);
        },
        onError: (error) => {
            console.error("Sync failed", error);
        },
    });
};